const VERSION: string = '0.1.7-prod.1'
export default VERSION;
